import React, { Component, Fragment } from 'react';

class TestInstanceStart extends Component {
    render() {
        const {
            id,
            deviceListDisplay,
            startStopInstance,
            startStopTest,
            displayButton,
            refreshDeviceList
        } = this.props;

        return(
            <div className="row">
                <div className="col-sm-4 ">
                    {displayButton ? (
                        <button
                            type="button"
                            className={`start-test-instance btn ${startStopTest.match(/Start/g) !== null
                                ? 'btn-success'
                                : 'btn-danger'}`}
                            onClick={() => startStopInstance(id)}
                        >
                            <span
                                className={`glyphicon glyphicon-${startStopTest.match(/Start/g) !== null
                                    ? 'play'
                                    : 'stop'}`}
                            />
                            {startStopTest}
                        </button>
                    ) : null}
                </div>

                <div className="col-sm-4 col-sm-offset-4">
                    <div className="test-instance-devices-list">
                        <div className="test-instance-overview-head text-center">
                            Device List ({deviceListDisplay && deviceListDisplay.length}){' '}
                            <button
                                className="btn btn-default"
                                onClick={refreshDeviceList}
                            >
                                <span className={`glyphicon glyphicon-refresh`}/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TestInstanceStart;